import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import FooterLayout from 'components/layouts/FooterLayout';

const FooterRoutes = ({
  component: Component,
  HeaderMenu,
  headerMenuStyles,
  withDownloadsSection,
  withSubScenery,
  pageStatus,
  ...rest
}) => (
  <>
    <div className={headerMenuStyles}>
      <HeaderMenu />
    </div>
    {pageStatus === 404
      ? (<Redirect to="/not-found" />) : (
        <Route
        // eslint-disable-next-line react/jsx-props-no-spreading
          {...rest}
          render={(props) => (
            <FooterLayout
              withDownloadsSection={withDownloadsSection}
              withSubScenery={withSubScenery}
            >
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <Component {...props} />
            </FooterLayout>
          )}
          status={pageStatus}
        />
      )}
  </>
);

FooterRoutes.defaultProps = {
  withDownloadsSection: false,
  withSubScenery: false,
  pageStatus: null,
};

FooterRoutes.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.object]).isRequired,
  HeaderMenu: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.object]).isRequired,
  headerMenuStyles: PropTypes.string.isRequired,
  withDownloadsSection: PropTypes.bool,
  withSubScenery: PropTypes.bool,
  pageStatus: PropTypes.number,
};

export default FooterRoutes;
